document.addEventListener("DOMContentLoaded", function () {
  function apply() {
    // アイコン追加
    document
      .querySelectorAll(".Avada-Accordion_Item-Button")
      .forEach((button) => {
        // アイコン未追加なら追加
        if (!button.querySelector(".c-question-icon")) {
          const img = document.createElement("img");
          img.src =
            "https://cdn.shopify.com/s/files/1/0938/8579/2560/files/question.png?v=1772219478";
          img.width = 22;
          img.height = 22;
          img.classList.add("c-question-icon");

          button.insertBefore(img, button.firstChild);
        }

        // クリック無効化
        button.style.pointerEvents = "none";

        // 常に開いた状態に固定
        button.setAttribute("aria-expanded", "true");
      });

    // パネルを常に表示
    document
      .querySelectorAll(".Avada-Accordion_Item-Panel")
      .forEach((panel) => {
        panel.removeAttribute("hidden");
        panel.style.display = "block";
      });

    // Category Titleにクラス付与
    document.querySelectorAll(".Avada-Faq_Category-Title").forEach((title) => {
      if (!title.classList.contains("c-heading-with-tableware")) {
        title.classList.add("c-heading-with-tableware");
      }
    });
    // カテゴリ名のテキスト調整
    document
      .querySelectorAll(".Avada-Faq_CategoryItem-title")
      .forEach((title) => {
        let text = title.textContent.trim();
        // 「全て」→「すべて」
        if (text === "全て") {
          title.textContent = "すべて";
          return;
        }
        // 「に関するご質問」を削除
        if (text.includes("に関するご質問")) {
          title.textContent = text.replace("に関するご質問", "");
        }
      });
  }

  const faqObserver = new MutationObserver(function () {
    apply();
  });

  faqObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  apply(); // 初回実行
});
